export default "__VITE_ASSET__CEv_hJoq__"